import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";
import { auth } from "../../../../firebase";
import { signOut } from "firebase/auth";
import { useAuth } from "../../../../providers/AuthProvider";
import axios from "axios";
const UserActions = () => {
  const { currentUser, setCurrentUser } = useAuth();
  const [visible, setVisible] = useState(false);
  const toggleUserActions = () => {
    setVisible(!visible);
  };

  const signout = async () => {
    await signOut(auth);
    setCurrentUser(null);
    delete axios.defaults.headers.common["Authorization"];
    // localStorage.removeItem('admin')
  };

  return (
    <NavItem tag={Dropdown} caret toggle={toggleUserActions}>
      <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
        <img
          className="user-avatar rounded-circle mr-2"
          src={require("./../../../../images/avatars/user.png")}
          alt="User Avatar"
        />{" "}
        <span className="d-none d-md-inline-block">
          {currentUser.displayName
            ? currentUser.displayName
            : currentUser.email
            ? currentUser.email
            : "User"}
        </span>
      </DropdownToggle>
      <Collapse tag={DropdownMenu} right small open={visible}>
        {/* <DropdownItem to="#">
          <i className="material-icons">&#xE7FD;</i> Profile
        </DropdownItem>
        <DropdownItem to="#">
          <i className="material-icons">&#xE8B8;</i> Edit Profile
        </DropdownItem>
        <DropdownItem to="#">
          <i className="material-icons">&#xE2C7;</i> Files
        </DropdownItem>
        <DropdownItem to="#">
          <i className="material-icons">&#xE896;</i> Transactions
        </DropdownItem>
        <DropdownItem divider /> */}
        <DropdownItem onClick={() => signout()}>
          <i className="material-icons">&#xE879;</i> Logout
        </DropdownItem>
      </Collapse>
    </NavItem>
  );
};

export default UserActions;
